import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@/styles/index.css';
import '@/shared/i18n/instance';

import { App } from '@/app/App';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Élément #root absent de index.html');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// L'ossature du site s'ouvre hors ligne (voir public/sw.js). En production seulement :
// en développement, un service worker servirait de vieux fichiers au rechargement.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
